export default '/mallapi'